import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

// Price matrix Tire API start

export const useFetchPriceMatrixTireData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  return useQuery({
    queryKey: ["priceMatrixTireData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/price-matix/tire/?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const usePriceMatrixTireCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/price-matix/tire`,
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Tire  Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Tire create request failed:", error.message);
    },
  });
};

export const useFetchAllPriceMatrixTireData = () => {
  return useQuery({
    queryKey: ["priceMatrixTireAllData"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/price-matix/tire/all`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data ?? []; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

interface UpdateTirePayload {
  id: string;
  name: string;
  countryId: string | null;
  coverageCity: string | null;
}
export const useUpdatePriceMatrixTireData = () => {
  return useMutation({
    mutationFn: async ({
      id,
      name,
      countryId,
      coverageCity,
    }: UpdateTirePayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/price-matix/tire/${id}`,
        "PUT",
        {
          name,
          countryId,
          coverageCity,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Tire update successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Tire update request failed:", error.message);
    },
  });
};

interface UpdateTireStatusPayload {
  id: string;
  status: any;
}
export const useUpdatePriceMatrixTireStatus = () => {
  return useMutation({
    mutationFn: async ({ id, status }: UpdateTireStatusPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/price-matix/tire/${id}`,
        "PATCH",
        {
          status,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Tire status updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Tire status update failed:", error.message);
    },
  });
};

// Price matrix Tire API end

// Price matrix API start

export const usePriceMatrixCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(`${url}/api/price-matix`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Price matrix  Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Price matrix create request failed:", error.message);
    },
  });
};

// apis/priceMatrixApis.ts
export const usePriceMatrixUpdateMutation = () => {
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: any }) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/price-matix/${id}`,
        "PUT",
        // {
          payload,
        // }
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data) => {
      console.log("Price matrix updated:", data);
    },
    onError: (error: any) => {
      console.error("Update failed:", error.message);
    },
  });
};

export const usePriceMatrixMutation = (page: number, limit: number) => {
  return useQuery({
    queryKey: ["priceMatrix", page, limit],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/price-matix/?page=${page}&limit=${limit}`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useUpdatePriceMatrixStatus = () => {
  return useMutation({
    mutationFn: async ({ id, status }: UpdateTireStatusPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/price-matix/${id}`,
        "PATCH",
        {
          status,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update Price Matrix status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Price Matrix status updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Price Matrix status update failed:", error.message);
    },
  });
};
